[
  "Notebook",
  "Desktop",
  "Servidor",
  "SSD",
  "RAM",
  "CPU",
  "GPU",
  "Placa Mãe",
  "Fonte",
  "Gabinete",
  "Monitor",
  "Impressora",
  "Switch",
  "Firewall",
  "Access Point",
  "Storage",
  "No-break",
  "Teclado",
  "Mouse",
  "Headset",
  "Roteador",
  "Cooler"
]
